import React, {useCallback} from 'react';
import {HeroMetadata, Metadata} from '../index';
import {isIE} from 'react-device-detect';

const ArticleContainer = props => {
    // eslint-disable-next-line id-length
    const onEnterOrSpaceDownHandler = useCallback(event => {
        if (event.keyCode === 13 || event.keyCode === 32) {
            props.openArticleModal(props.data, props.analyticsArgument);
        }
    }, [props]);

    const onClickHandler = useCallback(() => {
        props.openArticleModal(props.data, props.analyticsArgument);
    }, [props]);

    return (
        <article
            role="button"
            tabIndex="0"
            className={`${props.display} article-container`}
            onKeyDown={onEnterOrSpaceDownHandler}
            onClick={onClickHandler}
        >
            {!isIE &&
            <img
                src={props.data.src}
                className="article-img" alt="" role="presentation" />}
            {isIE && <img
                style={{backgroundImage: `url(${props.data.src})`, backgroundSize: `cover`, backgroundRepeat: `no-repeat`, backgroundPosition: `center`}}
                className="article-img" alt="" role="presentation" />}

            {props.isHero ?
                <HeroMetadata data={props.data} contentType={`article`} /> :
                <Metadata data={props.data} contentType={`article`} />
            }
            <div className="hover-overlay"></div>
        </article>
    );
};
ArticleContainer.defaultProps = {isHero: false};

export default ArticleContainer;
